import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {IField} from "~/cabinet/vue/interface/form/elements/Interfaces";


const __default__ = {
    name: "ChatFormInlineSvgIcon"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    field: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_ctx.field.icon)
    ? (_openBlock(), _createBlock(SvgIcon, {
        key: 0,
        style: {"margin-right":"0.7em !important"},
        "icon-name": _ctx.field.icon,
        "icon-style": _ctx.field.iconStyle
      }, null, 8, ["icon-name", "icon-style"]))
    : _createCommentVNode("", true)
}
}

})